var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/components/health-profile-page-wrapper/health-profile-page-wrapper.tsx
import * as React from "react";
import {
  useNavigateLegacy as useNavigate,
  LinkLegacy as Link
} from "@leagueplatform/routing";
import {
  Box,
  Flex,
  genesisStyled,
  HeadingOne
} from "@leagueplatform/genesis-commons";
import {
  BackButtonArrow,
  PageHeaderBackground
} from "@leagueplatform/web-common-components";
var PageContainer = genesisStyled(Flex)`
  max-width: 1272px;
`;
function HealthProfilePageWrapper({
  children,
  sidebar,
  title,
  hideBackButton = false,
  backButtonRoute
}) {
  const navigate = useNavigate();
  const backButtonDestination = backButtonRoute || "#";
  return /* @__PURE__ */ React.createElement(
    PageContainer,
    {
      flexWrap: { laptop: "noWrap", tablet: "wrap", phone: "wrap" },
      margin: "0 auto",
      paddingX: "one"
    },
    /* @__PURE__ */ React.createElement(
      Flex,
      {
        marginInlineStart: { _: "none", laptop: "two" },
        marginInlineEnd: { _: "none", laptop: "two" },
        flexGrow: 1,
        flexDirection: { _: "column" },
        width: "100%"
      },
      /* @__PURE__ */ React.createElement(PageHeaderBackground, null, /* @__PURE__ */ React.createElement(Flex, { alignItems: "center", paddingBottom: "one", position: "relative" }, !hideBackButton && /* @__PURE__ */ React.createElement(
        BackButtonArrow,
        {
          as: Link,
          to: backButtonDestination,
          fontSize: "heading1",
          marginInlineEnd: "one",
          marginY: "threeQuarters",
          justifyContent: "initial",
          onClick: (event) => {
            if (backButtonRoute) {
              return;
            }
            event.preventDefault();
            navigate(-1);
          },
          position: "absolute",
          insetInlineStart: { _: "0px", laptop: "-35px" },
          top: { _: "0px", laptop: "unset" }
        }
      ), /* @__PURE__ */ React.createElement(HeadingOne, { marginTop: { _: "oneAndHalf", laptop: "none" } }, title))),
      /* @__PURE__ */ React.createElement(Flex, { justifyContent: "space-between" }, /* @__PURE__ */ React.createElement(
        Box,
        {
          flexGrow: 1,
          flexShrink: 1,
          width: "100%",
          maxWidth: sidebar ? "890px" : null,
          marginBottom: { _: "180px", phone: "110px" },
          className: "health-profile-page-children-wrapper"
        },
        children
      ))
    ),
    sidebar && /* @__PURE__ */ React.createElement(
      Box,
      {
        padding: "none",
        height: "100%",
        width: { laptop: "initial", tablet: "100%", phone: "100%" },
        marginTop: "one"
      },
      sidebar
    )
  );
}

// src/components/more-options-card/more-options-card.tsx
import * as React2 from "react";
import {
  Box as Box2,
  css,
  genesisStyled as genesisStyled2,
  HeadingThree
} from "@leagueplatform/genesis-commons";
import { useIntl } from "@leagueplatform/locales";
import { SidebarCard } from "@leagueplatform/web-common-components";
var LinksContainer = genesisStyled2((props) => /* @__PURE__ */ React2.createElement(Box2, __spreadValues({ as: "ul" }, props)))(
  css({
    "li:not(:last-child)": {
      borderBottomColor: "onSurface.border.subdued",
      borderBottomStyle: "solid",
      borderBottomWidth: "thin"
    }
  })
);
function MoreOptionsCard({ children }) {
  const { formatMessage } = useIntl();
  return /* @__PURE__ */ React2.createElement(
    SidebarCard,
    {
      as: "nav",
      "aria-labelledby": "more-options-heading",
      paddingTop: { laptop: "oneAndHalf" },
      paddingX: { laptop: "oneAndHalf" },
      paddingBottom: { laptop: "half" }
    },
    /* @__PURE__ */ React2.createElement(HeadingThree, { id: "more-options-heading", marginBottom: "one", as: "h2" }, formatMessage({ id: "MORE_OPTIONS" })),
    /* @__PURE__ */ React2.createElement(LinksContainer, null, children)
  );
}

// src/components/more-options-card/add-apps-devices-link.tsx
import * as React4 from "react";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import { UnavailableDeviceConnectModal } from "@leagueplatform/health-programs";

// src/components/more-options-card/more-options-button.tsx
import * as React3 from "react";
import {
  Box as Box3,
  TextAction,
  Icon,
  ParagraphText
} from "@leagueplatform/genesis-core";
function MoreOptionsButton({
  id,
  onClick,
  children
}) {
  return /* @__PURE__ */ React3.createElement(Box3, { as: "li" }, /* @__PURE__ */ React3.createElement(
    TextAction,
    {
      onClick,
      as: "button",
      id,
      size: "medium",
      css: {
        alignItems: "center",
        borderRadius: "$medium",
        justifyContent: "space-between",
        marginY: "$half",
        paddingBottom: "$threeQuarters",
        paddingInlineStart: "$quarter",
        paddingTop: "$threeQuarters",
        textAlign: "start",
        textDecoration: "none",
        width: "100%",
        "&:hover": {
          backgroundColor: "$interactiveBackgroundDisabled",
          textDecoration: "none"
        }
      }
    },
    /* @__PURE__ */ React3.createElement(ParagraphText, { css: { fontWeight: "$headingThree" } }, children),
    /* @__PURE__ */ React3.createElement(Icon, { icon: "interfaceChevronForward" })
  ));
}

// src/components/more-options-card/add-apps-devices-link.tsx
function AddAppsDevicesLink({ onClick }) {
  const { formatMessage } = useIntl2();
  const [displayUnavailableOnWebModal, setDisplayUnavailableOnWebModal] = React4.useState(false);
  return /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(
    MoreOptionsButton,
    {
      onClick: () => {
        setDisplayUnavailableOnWebModal(true);
        onClick == null ? void 0 : onClick();
      }
    },
    formatMessage({ id: "ADD_APPS_DEVICES" })
  ), displayUnavailableOnWebModal ? /* @__PURE__ */ React4.createElement(
    UnavailableDeviceConnectModal,
    {
      onClose: () => setDisplayUnavailableOnWebModal(false)
    }
  ) : null);
}

// src/components/more-options-card/more-options-link.tsx
import * as React5 from "react";
import {
  Box as Box4,
  TextAction as TextAction2,
  Icon as Icon2,
  ParagraphText as ParagraphText2
} from "@leagueplatform/genesis-core";
import { LinkLegacy as Link2 } from "@leagueplatform/routing";
function MoreOptionsLink({
  id,
  onClick,
  children,
  to
}) {
  return /* @__PURE__ */ React5.createElement(Box4, { as: "li" }, /* @__PURE__ */ React5.createElement(
    TextAction2,
    {
      onClick,
      as: Link2,
      to,
      id,
      size: "medium",
      css: {
        alignItems: "center",
        borderRadius: "$medium",
        justifyContent: "space-between",
        marginY: "$half",
        paddingBottom: "$threeQuarters",
        paddingInlineStart: "$quarter",
        paddingTop: "$threeQuarters",
        textAlign: "start",
        textDecoration: "none",
        width: "100%",
        "&:hover": {
          backgroundColor: "$interactiveBackgroundDisabled",
          textDecoration: "none"
        }
      }
    },
    /* @__PURE__ */ React5.createElement(ParagraphText2, { css: { fontWeight: "$headingThree" } }, children),
    /* @__PURE__ */ React5.createElement(Icon2, { icon: "interfaceChevronForward", tint: "$primaryBackgroundHovered" })
  ));
}

// src/utils/utils.ts
var getPreferredFirstName = (userData) => {
  var _a, _b, _c, _d, _e;
  return (_e = (_d = (_c = (_a = userData == null ? void 0 : userData.userProfile) == null ? void 0 : _a.preferredFirstName) != null ? _c : (_b = userData == null ? void 0 : userData.userProfile) == null ? void 0 : _b.firstName) != null ? _d : userData == null ? void 0 : userData.email) != null ? _e : "";
};

// src/hooks/use-get-user-profile.hook.ts
import { useQuery } from "@tanstack/react-query";
import {
  getUserProfile,
  GET_USER_PROFILE_MESSAGE_TYPE
} from "@leagueplatform/user-profile-api";
import { captureError } from "@leagueplatform/observability";
import camelcaseKeys from "camelcase-keys";
var useGetUserProfile = () => useQuery([GET_USER_PROFILE_MESSAGE_TYPE], () => getUserProfile(), {
  select: (data) => camelcaseKeys(data, { deep: true }),
  onError: (error) => {
    captureError(new Error(`Unable to fetch users profile: ${error}`));
  }
});

// src/hooks/use-get-user-profile-data.hook.ts
var useGetUserProfileData = () => {
  var _a, _b;
  const { data } = useGetUserProfile();
  const preferredFirstName = getPreferredFirstName(data);
  return {
    avatar: (_a = data == null ? void 0 : data.userProfile) == null ? void 0 : _a.avatar,
    preferredFirstName,
    lastName: ((_b = data == null ? void 0 : data.userProfile) == null ? void 0 : _b.lastName) || null,
    data
  };
};

// src/index.ts
import { GET_USER_PROFILE_MESSAGE_TYPE as GET_USER_PROFILE_MESSAGE_TYPE2 } from "@leagueplatform/user-profile-api";
export {
  AddAppsDevicesLink,
  GET_USER_PROFILE_MESSAGE_TYPE2 as GET_USER_PROFILE_MESSAGE_TYPE,
  HealthProfilePageWrapper,
  MoreOptionsButton,
  MoreOptionsCard,
  MoreOptionsLink,
  useGetUserProfileData
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/health-profile-common'] = window.leagueSDKsPresent['@leagueplatform/health-profile-common'] || [];
    window.leagueSDKsPresent['@leagueplatform/health-profile-common'].push('2.28.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/health-profile-common'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/health-profile-common module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map